<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="600" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ title }}
            </h3>
        </template>

        <template #default>
            <p>
                {{ question }}
            </p>
        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-trash-can"
                    color="error" @click="confirmDeletion(formData)">{{ $t('global.yes') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "ConfirmDeletionDialog",
};
</script>
<script setup>

import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';

const softToken = localStorage.getItem("softToken");
const hardToken = localStorage.getItem("hardToken");
const username = localStorage.getItem("username");
const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data"); // Handles v-model for the object
defineProps({
    confirmDeletion: Function, // Define prop as a function
    title: { 
        type: String, 
        default: 'Delete Entry'
    },
    question: { 
        type: String, 
        default: 'Are you sure ?'
    },
});
const { proxy } = getCurrentInstance();

// watch(dialogVisible, (newValue) => {
//     if (!newValue) {
//         formData.value = null
//     }
// });

const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = null;
}
onMounted(() => {

});
</script>
